"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyname = _interopRequireDefault(require("keyname"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The trigger button component to be used as the component
 * that triggers the opening of an <OptionsMenu />.
 *
 * NOTE: This component should be used to set/update the <OptionsMenu /> "show" property
 */
var OptionsMenuTrigger =
/*#__PURE__*/
function (_Component) {
  _inherits(OptionsMenuTrigger, _Component);

  function OptionsMenuTrigger() {
    var _this;

    _classCallCheck(this, OptionsMenuTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionsMenuTrigger).call(this));
    _this.state = {
      expanded: false
    };
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OptionsMenuTrigger, [{
    key: "render",
    value: function render() {
      var expanded = this.state.expanded;

      var _this$props = this.props,
          triggerRef = _this$props.triggerRef,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["triggerRef", "className"]);

      return _react["default"].createElement("button", _extends({
        type: "button"
      }, other, {
        "aria-expanded": expanded,
        className: (0, _classnames["default"])('dqpl-options-menu-trigger', className),
        ref: triggerRef,
        onKeyDown: this.onKeyDown,
        onClick: this.onClick
      }));
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      this.props.onClick(e);
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      this.props.onKeyDown(e);
      var which = e.which,
          target = e.target;
      var key = (0, _keyname["default"])(which);

      if (key === 'down') {
        e.preventDefault();
        target.click();
      }
    }
  }]);

  return OptionsMenuTrigger;
}(_react.Component);

exports["default"] = OptionsMenuTrigger;

_defineProperty(OptionsMenuTrigger, "propTypes", {
  onKeyDown: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  triggerRef: _propTypes["default"].func,
  className: _propTypes["default"].string
});

_defineProperty(OptionsMenuTrigger, "defaultProps", {
  onKeyDown: function onKeyDown() {},
  onClick: function onClick() {},
  triggerRef: function triggerRef() {}
});